import InvitationApp from "Invitation/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const advancingRoute: RouteObject = {
  path: "advancing",
  children: [{
    path: "invitation/:secret",
    loader: () => viewModel,
    Component: InvitationApp,
  }]
};